export const RULE_SETS: string[] = [
	'All Rulesets',
	'Default Rules',
	'Basic Monitoring',
	'Standard Assessment',
	'Strict Assessment',
	'High Security',
	'Enterprise Rules',
	'Campus Hiring',
	'Remote Examination',
	'Internal Quiz Beta'
];



export const PROCTORED_STATUS_OPTIONS: string[] = [
	'All Statuses',
	'Active',
	'Inactive'
];

export interface ProctoredRule {
	name: string;
	description: string;
}


export const PROCTORED_RULES_NAME_DESCRIPTION: ProctoredRule[] = [
	{
		name: 'Face Not Detected',
		description: 'Triggers when no face is detected in the camera.'
	},
	{
		name: 'Multiple Faces Detected',
		description: 'Triggers when more than one face is detected.'
	},
	{
		name: 'Eyes Closed',
		description: 'Triggers when the candidate keeps their eyes closed for a prolonged period.'
	},
	{
		name: 'Looking Away',
		description: 'Triggers when the candidate looks away from the screen.'
	},
	{
		name: 'Head Pose Out Of Range',
		description: 'Triggers when the candidate moves their head outside the allowed range.'
	},
	{
		name: 'Face Too Far',
		description: 'Triggers when the candidate moves too far away from the camera.'
	},
	{
		name: 'Mobile Phone Detected',
		description: 'Triggers when a mobile phone is detected.'
	},
	{
		name: 'Extra Person Detected',
		description: 'Triggers when another person is detected in the camera frame.'
	},
	{
		name: 'Virtual Camera Detected',
		description: 'Triggers when a virtual camera is being used.'
	},
	{
		name: 'Background Noise',
		description: 'Triggers when significant background noise is detected.'
	},
	{
		name: 'Multiple Voices',
		description: 'Triggers when more than one voice is detected.'
	},
	{
		name: 'Voice Changed',
		description: 'Triggers when an unexpected voice change is detected.'
	},
	{
		name: 'Microphone Disabled',
		description: 'Triggers when the microphone is disabled during the assessment.'
	},
	{
		name: 'Camera Disabled',
		description: 'Triggers when the camera is disabled during the assessment.'
	},
	{
		name: 'Tab Switch',
		description: 'Triggers when the user switches browser tabs.'
	},
	{
		name: 'Window Minimize',
		description: 'Triggers when the assessment window is minimized.'
	},
	{
		name: 'Window Blur',
		description: 'Triggers when the assessment window loses focus.'
	},
	{
		name: 'Screen Change',
		description: 'Triggers when the shared screen changes.'
	},
	{
		name: 'Screen Share Stopped',
		description: 'Triggers when screen sharing is stopped.'
	},
	{
		name: 'Fullscreen Exit',
		description: 'Triggers when the user exits fullscreen mode.'
	},
	{
		name: 'Screenshot Attempt',
		description: 'Triggers when a screenshot attempt is detected.'
	},
	{
		name: 'Browser Refresh',
		description: 'Triggers when the browser page is refreshed.'
	},
	{
		name: 'Device Change',
		description: 'Triggers when the input or output device changes.'
	},
	{
		name: 'Network Disconnect',
		description: 'Triggers when the internet connection is lost.'
	},
	{
		name: 'VPN Detection',
		description: 'Triggers when a VPN connection is detected.'
	},
	{
		name: 'Remote Desktop Detection',
		description: 'Triggers when remote desktop software is detected.'
	},
	{
		name: 'Context Menu Blocked',
		description: 'Triggers when the user attempts to open the context menu.'
	},
	{
		name: 'Copy',
		description: 'Triggers when the user copies content.'
	},
	{
		name: 'Paste',
		description: 'Triggers when the user pastes content.'
	},
	{
		name: 'DevTools Open',
		description: 'Triggers when browser developer tools are opened.'
	},
	{
		name: 'Face Expression',
		description: 'Triggers when suspicious facial expressions are detected.'
	}
];